import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  standalone: false,
  name: 'ingsvTime'
})
export class TimePipe implements PipeTransform {
  transform(time: string, format: string): any {
    const defaultFormat = 'YYYY-MM-DD HH:mm:ss';

    return moment(time, defaultFormat).format(format);
  }
}
